import { render, staticRenderFns } from "./skladista.editor.vue?vue&type=template&id=6359747d&"
import script from "./skladista.editor.vue?vue&type=script&lang=ts&"
export * from "./skladista.editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports